import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExtraDatasService {
  private apiUrl = environment.apiUrl;
  private httpClient = inject(HttpClient);

  private headers = new HttpHeaders({
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  });

  async getByKey(key: string): Promise<string | null> {
    const timestamp = new Date().getTime();
    const response: any = await firstValueFrom(
      this.httpClient.get(`${this.apiUrl}/extra-datas?key=${key}&t=${timestamp}`, { headers: this.headers })
    );
    return response?.data?.value ?? null;
  }

  async getContactData() {
    const headers = this.headers;
    const timestamp = new Date().getTime();
    const [address, phone, mapLink, email] = await Promise.all([
      firstValueFrom(this.httpClient.get(`${this.apiUrl}/extra-datas?key=contact_address&t=${timestamp}`, { headers })),
      firstValueFrom(this.httpClient.get(`${this.apiUrl}/extra-datas?key=contact_phone&t=${timestamp}`, { headers })),
      firstValueFrom(this.httpClient.get(`${this.apiUrl}/extra-datas?key=contact_map&t=${timestamp}`, { headers })),
      firstValueFrom(this.httpClient.get(`${this.apiUrl}/extra-datas?key=contact_email&t=${timestamp}`, { headers })),
    ]);

    return { address, phone, mapLink, email };
  }
}
